import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Comment } from '../models/comment';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { CommentDTO } from './comment-dto';
import { MaCommentsPopupService } from './ma-comments-popup-service';
import { MultiCommentDTO, MultiCommentStatusDTO } from '../ma-comments-popup/comment-dto';

@Component({
  selector: 'app-ma-comments-popup',
  templateUrl: './ma-comments-popup.component.html',
  styleUrls: ['./ma-comments-popup.component.css']
})
export class MaCommentsPopupComponent implements OnInit {

  constructor(private commentService: MaCommentsPopupService, private _messagesService: MessagesService) { }
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string = "";
  selectedLabId: string = "";
  showPlateCommentsList: boolean = false;
  newComment: string = "";
  blocked: boolean = false;
  toggleMultiComments: boolean = false
  enteredPlateId: string = "";
  multiUpdatePlateList = [];
  plateStatusMap = {};
  updateMultiPlateCommentsCheckBox: boolean = true;

  @Input() extraction?: boolean = false;
  @Input() selectedPlateID: string;
  @Input() selectedPlateStatus: string;
  @Input() selectedBeadchipStatus: string;
  @Input() beadChipID: string;
  @Input() beadChipCommentsDisplayMap: Map<string, boolean>;
  @Input() beadChipCommentsMap: Map<string, Comment[]>;
  @Input() plateCommentList: Comment[];
  @Output() backButtonEmitter = new EventEmitter();
  @Input() qcScan?: boolean = false;
  @Input() disableInput: boolean = false;
  @Input() multiPlateIdList?: Array<string> = []
  @Input() multiPlateCommentMode:boolean = false;


  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.showPlateCommentsList = false;
  }

  getCommentDTO() {
    let newComment: CommentDTO = new CommentDTO();
    newComment.puid = this.puid;
    newComment.labid = this.selectedLabId;
    newComment.comment = this.newComment;
    newComment.platecomment = true;
    newComment.beadchipid = this.beadChipID;
    newComment.beadchipstatus = this.selectedBeadchipStatus;
    newComment.plateid = this.selectedPlateID;
    newComment.status = this.selectedPlateStatus;
    return newComment;

  }

  checkPlate() {
    if (this.enteredPlateId == "") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Please add a plate', detail: "Add a valid plate" })
      return
    }
    if (this.multiUpdatePlateList.includes(this.enteredPlateId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Plate already added', detail: "The plate has already been added" })
      return
    }
    this.commentService.checkIfPlateExists(this.selectedLabId, this.enteredPlateId).subscribe(res => {
      if (res.data.present) {
        this.multiUpdatePlateList.push(this.enteredPlateId)
        this.plateStatusMap[this.enteredPlateId] = res.plate_status
        this.enteredPlateId = ""
      }
      else {
        this.enteredPlateId = ""
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Plate not present', detail: "Please enter a valid plate" })
      }
    })
  }

  deleteValue(index) {
    this.multiUpdatePlateList.splice(index, 1);
  }


  toggleMultiCommentsPopup() {
    this.multiUpdatePlateList = []
    this.toggleMultiComments = true
  }

  closePopup() {
    this.toggleMultiComments = false
  }

  saveComment() {
    if (this.multiPlateCommentMode && this.updateMultiPlateCommentsCheckBox) {
      this.saveMultiComment();
      return;
    }
    this.saveSinglePlateComment();
  }

  saveSinglePlateComment() {
    this.commentService.updateComment(this.getCommentDTO()).subscribe(
      (result) => {
        if (this.extraction) {
          this.commentService.commentDetailsbyPlateId(this.selectedLabId, this.selectedPlateID).subscribe(
            (res) => {
              this.selectedPlateID = res.plateID;
              this.selectedPlateStatus = res.status;
              this.plateCommentList = res.comments;
              if (res && res.beadChips) {
                res.beadChips.forEach(beadChip => {
                  this.beadChipCommentsMap.set(beadChip.beadChipID, beadChip.comments)
                  this.beadChipCommentsDisplayMap.set(beadChip.beadChipID, false);
                })
              }
            },
            (error) => {
              this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
            }
          )
        }
        this.newComment = "";
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.backButtonEmitter.emit(true);
      },
      (error) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  saveMultiComment() {
    this.commentService.updateMultiComment(this.getMultiPlateCommentDTO()).subscribe(
      (result) => {
        if (this.extraction) {
          this.commentService.commentDetailsbyPlateId(this.selectedLabId, this.selectedPlateID).subscribe(
            (res) => {
              this.selectedPlateID = res.plateID;
              this.selectedPlateStatus = res.status;
              this.plateCommentList = res.comments;
              if (res && res.beadChips) {
                res.beadChips.forEach(beadChip => {
                  this.beadChipCommentsMap.set(beadChip.beadChipID, beadChip.comments)
                  this.beadChipCommentsDisplayMap.set(beadChip.beadChipID, false);
                })
              }
            },
            (error) => {
              this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
            }
          )
        }
        this.newComment = "";
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.backButtonEmitter.emit(true);
      },
      (error) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  getMultiPlateCommentDTO() {
    let multiComment = new MultiCommentStatusDTO();
    multiComment.plateids = this.multiPlateIdList
    multiComment.status = this.selectedPlateStatus;
    multiComment.comment = this.newComment;
    multiComment.labid = this.selectedLabId;
    multiComment.platecomment = true;
    multiComment.puid = this.puid;
    multiComment.beadchipstatus = "";
    multiComment.beadchipids = [];
    return multiComment;
  }

  saveMultiCommentStatus() {
    let multiComment = new MultiCommentStatusDTO();
    multiComment.plateids = this.multiUpdatePlateList
    multiComment.status = this.plateStatusMap;
    multiComment.comment = this.newComment;
    multiComment.labid = this.selectedLabId;
    multiComment.platecomment = true;
    multiComment.puid = this.puid;
    multiComment.beadchipstatus = "";
    multiComment.beadchipids = [];


    this.commentService.updateMultiCommentStatus(multiComment).subscribe(
      (result) => {
        if (this.selectedPlateID) {
          this.commentService.commentDetailsbyPlateId(this.selectedLabId, this.selectedPlateID).subscribe(
            (res) => {
              this.selectedPlateID = res.plateID;
              this.selectedPlateStatus = res.status;
              this.plateCommentList = res.comments;
              if (res && res.beadChips) {
                res.beadChips.forEach(beadChip => {
                  this.beadChipCommentsMap.set(beadChip.beadChipID, beadChip.comments)
                  this.beadChipCommentsDisplayMap.set(beadChip.beadChipID, false);
                })
              }
            },
            (error) => {
              this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
            }
          )
        }

        this.newComment = "";
        this.multiUpdatePlateList = []
        this.plateStatusMap = {}
        this.toggleMultiComments = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
      },
      (error) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    );
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  setBeadchipDisplay(beadChip: string, bool: boolean) {
    this.beadChipCommentsDisplayMap.set(beadChip, bool);
  }

  convertUtcToLocal(date: Date): Date {
    if (!date || date == null) return;
    var offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes() - offset);
    return dateInLocal;
  }

  extractionAndQcScan() {
    return this.extraction || this.qcScan;
  }
  
  notExtractionAndQcScan() {
    return !this.extraction && !this.qcScan;
  }
}
